// src/addonTally/index.js — 🎯 the "Add-ons today" tap counter (v126.5, spec
// Part 2). Lives on the clock screen (the store's home). Big till-friendly
// +1 taps, a small −1 undo, tally vs target, a celebration when you hit it.
//
// THE rule (spec): this is the store's OWN reference counter — the official
// numbers stay addon_actuals from the till uploads, and badges never read
// the tally. Taps are PIN-less (deliberate bounded exception); the manager
// target override asks for the PIN (it's a decision, not a count).

import { askSecret } from '../shared/ask-secret.js';   // v133.120: the manager PIN never in a prompt() box
import '../shared/confirm-dialog.js';   // v134.2: sets window.uiConfirm for the staff app (this bundle loads on every page)
import { visiblePoll } from '../shared/visible-poll.js';   // v136.8: no tally refresh while the page is hidden

function api(path, opts) {
  opts = opts || {};
  var base = (typeof DB !== 'undefined' && DB.workerUrl) ? DB.workerUrl() : '';
  return fetch(base + path, { method: opts.method || 'GET', headers: { 'Content-Type': 'application/json' }, body: opts.body, cache: 'no-store' });
}
function esc(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
// Phase C4: the tenant's word for "Add-ons" (falls back to the toy label for
// ELC, so an empty taxonomy is byte-identical). esc() it — a tenant label is
// data, not markup.
function addonWord() {
  var w = (typeof DB !== 'undefined' && DB.term) ? DB.term('addons', 'Add-ons') : 'Add-ons';
  return esc(w);
}
function myStore() {
  try { return (typeof currentStore !== 'undefined' && currentStore) ? (currentStore.name || currentStore) : null; } catch (e) { return null; }
}
// v135.1: a prompt() box is not part of the page, so the translator layer cannot reach it; ask I18N directly.
function tr(s) { return (typeof I18N !== 'undefined' && I18N.t) ? I18N.t(s) : s; }

var _data = null;          // { day, categories: [...], by_staff: [...] } for today

// ── WHO is counting (v126.21, Matt: "can they enter their pin so we can see
// how many each person has sold?") — picked ONCE per session (name + PIN,
// the chat-send model): every tap carries both; the server verifies and
// files a per-person row alongside the store total. Switch = one tap. ──────
var _who = null;           // { id, name }
var _pin = null;
var _pendingBump = null;   // [category, delta] stashed while the picker is open

function whoChipHtml() {
  return '<div style="padding:0 14px 6px">' +
    (_who
      ? '<span onclick="AddonTally.openWho()" style="display:inline-flex;align-items:center;gap:6px;background:var(--elc-green-soft);border:1.5px solid var(--elc-green,#009E3D);border-radius:10px;padding:5px 10px;font-size:12px;font-weight:800;cursor:pointer">👤 Counting as ' + esc(_who.name) + ' <span style="color:var(--tiny);font-weight:700">· switch</span></span>'
      : '<span onclick="AddonTally.openWho()" style="display:inline-flex;align-items:center;gap:6px;background:var(--warn-bg);border:1.5px solid #f5a623;border-radius:10px;padding:5px 10px;font-size:12px;font-weight:800;cursor:pointer">👤 Who&rsquo;s counting? Tap to pick your name</span>') +
    '</div>';
}

function openWho(errMsg) {
  var old = document.getElementById('atWhoModal'); if (old) old.remove();
  var roster = [];
  // v127.39 (a store manager, Doha - Lulu Express QF, 28 Jul): pass TODAY so the roster
  // includes cover staff rostered to work HERE (getStoreRoster's v113.0 second
  // arg — the checks/logs pickers already pass it; this one didn't, so a
  // supporter transferred to another store vanished from the picker and hit
  // the "pick a name first" loop). Business day (3am rule), same as the
  // server's tallyBusinessDay. The bump route verifies any staff PIN, so the
  // attribution lands correctly once the name is pickable.
  try {
    var day = (typeof businessDayStr === 'function') ? businessDayStr()
      : (typeof localDateStr === 'function' ? localDateStr(new Date()) : null);
    roster = (typeof getStoreRoster === 'function') ? (getStoreRoster(myStore(), day) || []) : [];
  } catch (e) {}
  var wrap = document.createElement('div');
  wrap.id = 'atWhoModal';
  wrap.style.cssText = 'position:fixed;inset:0;background:var(--overlay);z-index:9000;display:flex;align-items:center;justify-content:center;padding:16px';
  wrap.innerHTML = '<div style="background:var(--card);border-radius:16px;max-width:360px;width:100%;padding:18px">' +
    '<div style="font-weight:900;font-size:15px">👤 Who&rsquo;s counting?</div>' +
    '<div style="font-size:12px;color:var(--tiny);margin:4px 0 10px">Your taps count for YOU as well as the store — pick your name and enter your PIN once. Switch any time.</div>' +
    '<select id="atWhoSel" style="width:100%;border:1.5px solid var(--border,#dde3e8);border-radius:10px;padding:9px;font-size:14px;font-family:inherit;margin-bottom:8px"><option value="">— pick your name —</option>' +
      roster.map(function (p) { return '<option translate="no" value="' + p.id + '">' + esc(p.name) + '</option>'; }).join('') + '</select>' +
    '<input id="atWhoPin" type="password" inputmode="numeric" maxlength="8" placeholder="Your PIN" style="width:100%;box-sizing:border-box;border:1.5px solid var(--border,#dde3e8);border-radius:10px;padding:9px;font-size:14px;font-family:inherit">' +
    '<div id="atWhoErr" style="color:var(--danger-deep);font-size:12px;min-height:16px;margin-top:4px">' + esc(errMsg || '') + '</div>' +
    '<div style="display:flex;gap:8px;margin-top:6px">' +
      '<button onclick="AddonTally.saveWho()" style="flex:1;border:none;background:var(--elc-green,#009E3D);color:#fff;font-weight:800;font-size:14px;padding:10px;border-radius:10px;cursor:pointer;font-family:inherit">Start counting</button>' +
      '<button onclick="document.getElementById(\'atWhoModal\').remove()" style="flex:1;border:1.5px solid var(--border,#dde3e8);background:var(--card);font-weight:700;font-size:14px;padding:10px;border-radius:10px;cursor:pointer;font-family:inherit">Cancel</button>' +
    '</div></div>';
  wrap.addEventListener('click', function (e) { if (e.target === wrap) wrap.remove(); });
  document.body.appendChild(wrap);
}

function saveWho() {
  var sel = document.getElementById('atWhoSel');
  var pin = String((document.getElementById('atWhoPin') || {}).value || '').trim();
  var errEl = document.getElementById('atWhoErr');
  if (!sel || !sel.value) { if (errEl) errEl.textContent = 'Pick your name first.'; return; }
  if (pin.length < 4) { if (errEl) errEl.textContent = 'Enter your PIN.'; return; }
  _who = { id: Number(sel.value), name: sel.options[sel.selectedIndex].text };
  _pin = pin;   // verified by the server on the first tap; a wrong PIN re-opens this
  var m = document.getElementById('atWhoModal'); if (m) m.remove();
  render();
  if (_pendingBump) { var pb = _pendingBump; _pendingBump = null; bump(pb[0], pb[1]); }
}

function byStaffHtml(d) {
  var list = (d && d.by_staff) || [];
  if (!list.length) return '';
  return '<div style="padding:2px 14px 10px">' +
    '<div style="font-size:11px;font-weight:800;color:var(--sub,#5e6863);text-transform:uppercase;letter-spacing:.04em;padding:6px 0 4px">👥 Today by person</div>' +
    list.slice(0, 8).map(function (s) {
      var cats = Object.keys(s.counts || {}).map(function (c) {
        var m = _data && _data.categories && _data.categories.find(function (x) { return x.category === c; });
        return (m ? m.emoji : c) + ' ' + s.counts[c];
      }).join('  ');
      return '<div style="display:flex;align-items:baseline;gap:8px;padding:3px 0;font-size:13px"><span translate="no" style="font-weight:800">' + esc(s.name) + '</span>' +
        '<span style="font-weight:900;color:var(--elc-green,#009E3D)">' + s.total + '</span>' +
        '<span style="font-size:11.5px;color:var(--tiny)">' + esc(cats) + '</span></div>';
    }).join('') + '</div>';
}

async function fetchTally() {
  var st = myStore();
  if (!st) return null;
  try {
    var res = await api('/api/addon-tally?store=' + encodeURIComponent(st));
    if (!res.ok) return null;
    var d = await res.json();
    if (d && d.ok) { _data = d; return d; }
  } catch (e) { /* offline — the card just doesn't render */ }
  return null;
}

function rowHtml(c) {
  var hit = c.target != null && c.count >= c.target;
  // v126.15 (Matt: "it should also show the days kpi target and their %
  // completion") — every row shows count / target · % plus a progress bar.
  // The NUMBER is uncapped, the BAR is capped. These used to share one
  // Math.min(100, ...) value, so a store that beat its target still read
  // "11 / 6 · 100%" and the extra work simply vanished (staff report,
  // Dubai Hills, 22 Aug 2026). A bar cannot be wider than its track; a
  // percentage can happily be 183.
  var pct = c.target != null && c.target > 0 ? Math.round((c.count / c.target) * 100) : null;
  var barPct = pct != null ? Math.min(100, pct) : null;
  var bar = barPct != null
    ? '<div style="height:5px;background:var(--surface-3);border-radius:3px;margin-top:4px;overflow:hidden"><div style="height:100%;width:' + barPct + '%;background:' + (hit ? 'var(--elc-green,#009E3D)' : '#f5a623') + ';border-radius:3px"></div></div>'
    : '';
  return '<div style="display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid var(--surface-3)">' +
    '<span style="font-size:20px;flex-shrink:0">' + c.emoji + '</span>' +
    '<div style="flex:1;min-width:0"><div style="font-weight:800;font-size:13px">' + esc(c.name) + (hit ? ' <span style="font-size:12px">✨ target hit!</span>' : '') + '</div>' +
    '<div onclick="AddonTally.setTarget(\'' + c.category + '\')" style="font-size:11.5px;color:' + (hit ? 'var(--elc-green,#009E3D)' : 'var(--tiny)') + ';font-weight:700;cursor:pointer" title="Manager: tap to set today\'s target">' +
      c.count + (c.target != null ? ' / ' + c.target + (pct != null ? ' · ' + pct + '%' : '') + (c.overridden ? ' ✎' : '') : ' today — no target yet') + '</div>' + bar + '</div>' +
    '<button onclick="AddonTally.bump(\'' + c.category + '\',-1)" aria-label="undo one" style="width:34px;height:34px;border-radius:17px;border:1.5px solid var(--border,#dde3e8);background:var(--card);font-size:16px;cursor:pointer;color:var(--tiny)">−</button>' +
    '<button onclick="AddonTally.bump(\'' + c.category + '\',1)" aria-label="add one" style="width:52px;height:44px;border-radius:12px;border:none;background:var(--elc-green,#009E3D);color:#fff;font-size:18px;font-weight:900;cursor:pointer">+1</button>' +
    '</div>';
}

// v126.8 (Matt: declutter the clock screen) — the FULL tap counter lives on
// the KPI screen; the clock screen keeps a one-line TOTAL vs TARGET strip
// that taps through. Same data, two surfaces.
var _lastError = '';   // shown INLINE in the card — a quiet toast was too easy to miss

async function render() {
  var el = document.getElementById('addonTallyCard');
  var d = _data || await fetchTally();
  renderStrip(d);
  if (!el) return;
  if (!d || !d.categories) { el.innerHTML = ''; el.style.display = 'none'; return; }
  el.style.display = 'block';
  // v126.15: the day's headline — total vs summed target + overall %.
  var tot = 0, tgt = 0, anyT = false;
  d.categories.forEach(function (c) { tot += c.count; if (c.target != null) { tgt += c.target; anyT = true; } });
  // Uncapped for the same reason as the per-row figure: this drives text and a
  // colour threshold, never a bar width, so capping it only hid good days.
  var totPct = anyT && tgt > 0 ? Math.round((tot / tgt) * 100) : null;
  el.innerHTML =
    '<div style="padding:10px 14px 2px;display:flex;align-items:center;gap:6px">' +
      '<span style="font-size:11px;font-weight:800;color:var(--sub,#5e6863);text-transform:uppercase;letter-spacing:.04em">🎯 ' + addonWord() + ' today — your own count</span>' +
      '<span style="margin-inline-start:auto;font-size:10px;color:var(--stores-ink-3)">till data stays official</span></div>' +
    '<div style="padding:6px 14px 2px;display:flex;align-items:baseline;gap:8px">' +
      '<span style="font-size:26px;font-weight:900;color:' + (totPct != null && totPct >= 100 ? 'var(--elc-green,#009E3D)' : 'var(--text)') + '">' + tot + '</span>' +
      (anyT ? '<span style="font-size:14px;font-weight:800;color:var(--tiny)">/ ' + tgt + ' today' + (totPct != null ? ' · ' + totPct + '%' : '') + '</span>' : '<span style="font-size:12px;color:var(--stores-ink-3)">today — no sales target uploaded for today yet (targets match the KPI Day tab; managers can set one on any line)</span>') +
    '</div>' +
    whoChipHtml() +
    (_lastError ? '<div style="margin:4px 14px;padding:8px 12px;background:var(--danger-bg);border-radius:10px;color:var(--danger-deep);font-size:12px;font-weight:700">⚠️ ' + esc(_lastError) + '</div>' : '') +
    '<div style="padding:0 14px 8px">' + d.categories.map(rowHtml).join('') + '</div>' +
    byStaffHtml(d);
}

// The compact clock-screen strip: total vs summed target, tap → KPI screen.
function renderStrip(d) {
  var el = document.getElementById('addonTallyStrip');
  if (!el) return;
  if (!d || !d.categories) { el.innerHTML = ''; el.style.display = 'none'; return; }
  var total = 0, target = 0, anyTarget = false;
  d.categories.forEach(function (c) {
    total += c.count;
    if (c.target != null) { target += c.target; anyTarget = true; }
  });
  var hit = anyTarget && total >= target;
  el.style.display = 'block';
  el.innerHTML = '<div onclick="if(typeof switchScreen!==\'undefined\'){switchScreen(\'kpi\');if(typeof switchKpiTab!==\'undefined\')switchKpiTab(\'addons\')}" style="display:flex;align-items:center;gap:8px;padding:10px 14px;cursor:pointer">' +
    '<span style="font-size:16px">🎯</span>' +
    '<span style="font-size:13px;font-weight:800">' + addonWord() + ' today: ' +
      '<span style="color:' + (hit ? 'var(--elc-green,#009E3D)' : 'inherit') + '">' + total + (anyTarget ? ' / ' + target : '') + '</span>' +
      (hit ? ' ✨' : '') + '</span>' +
    '<span style="margin-inline-start:auto;font-size:12px;font-weight:800;color:var(--elc-green,#009E3D)">Count them ›</span></div>';
}

// ── The tap (optimistic; honest toast on a real failure) ─────────────────────
async function bump(category, delta) {
  // v126.21 — the tap needs a WHO first (once per session, then invisible).
  if (!_who || !_pin) { _pendingBump = [category, delta]; openWho(); return; }
  var c = _data && _data.categories.find(function (x) { return x.category === category; });
  if (c) { c.count = Math.max(0, c.count + delta); _lastError = ''; render(); }
  try {
    var st = myStore();
    var res = await api('/api/addon-tally/bump', { method: 'POST', body: JSON.stringify({ category: category, delta: delta, store: st, auth_staff_id: _who.id, auth_pin: _pin }) });
    var d = await res.json().catch(function () { return {}; });
    if (res.status === 401 || res.status === 403 || res.status === 429) {
      // Wrong/locked PIN — roll back, forget the PIN, re-ask with the reason.
      if (c) { c.count = Math.max(0, c.count - delta); }
      _pin = null; _pendingBump = [category, delta];
      render();
      openWho((d && d.error) || 'PIN not recognised — try again');
      return;
    }
    if (!res.ok) {
      // v126.8 (Matt: "just sits staticky") — the rollback made a failing tap
      // look like nothing happened. The error is now INLINE in the card.
      if (c) { c.count = Math.max(0, c.count - delta); }
      _lastError = (d && d.error) || 'Could not save that tap — try again';
      render();
      if (typeof showToast !== 'undefined') showToast(_lastError, 'error');
      return;
    }
    if (c && d.count != null) { c.count = Number(d.count); render(); }
    if (c && delta > 0 && c.target != null && c.count === c.target && typeof showToast !== 'undefined') {
      showToast('✨ ' + c.name + ' target hit — brilliant!');
    }
  } catch (e) {
    if (c) { c.count = Math.max(0, c.count - delta); }
    _lastError = 'Offline — that tap did not save';
    render();
    if (typeof showToast !== 'undefined') showToast(_lastError, 'error');
  }
}

// ── The manager override (a decision → PIN) ──────────────────────────────────
async function setTarget(category) {
  var c = _data && _data.categories.find(function (x) { return x.category === category; });
  var t = prompt(tr('Today\'s target for ' + (c ? c.name : category) + ' (blank = back to automatic):'), c && c.overridden && c.target != null ? c.target : '');
  if (t === null) return;
  var pinInfo = await askSecret({ title: 'Manager PIN', note: 'Managers only.', kind: 'pin', okLabel: 'Confirm' });   // v133.120: hidden, never a prompt() box
  if (!pinInfo) return;
  // Which manager? The till knows its staff; ask the worker to verify by PIN —
  // we send the pin with each candidate manager id is overkill, so the server
  // accepts auth via the store roster: we pass the FIRST manager match client-
  // side. Simplest honest path: ask for the manager's staff number too.
  var who = prompt(tr('Your staff ID number (shown on your My Development page):'));
  if (!who) return;
  try {
    var res = await api('/api/addon-tally/target', { method: 'POST', body: JSON.stringify({ category: category, target: t === '' ? null : Number(t), auth_staff_id: Number(who), auth_pin: pinInfo }) });
    var d = await res.json().catch(function () { return {}; });
    if (!res.ok) { if (typeof showToast !== 'undefined') showToast((d && d.error) || 'Could not set the target', 'error'); return; }
    _data = null; render();
    if (typeof showToast !== 'undefined') showToast('🎯 Target updated');
  } catch (e) { if (typeof showToast !== 'undefined') showToast('Could not set the target — check the connection', 'error'); }
}

// ── Boot (same lazy pattern as the badge shelf — never on the boot payload) ──
var _booted = false;
function boot() {
  if (_booted || typeof document === 'undefined') return;
  _booted = true;
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    // v136.8: the 10-minute refresh rests while the page is hidden (one catch-up on return)
    if (myStore()) { clearInterval(t); render(); visiblePoll(function () { _data = null; render(); }, 10 * 60 * 1000); }
    else if (tries > 60) clearInterval(t);
  }, 2000);
}
if (typeof window !== 'undefined') boot();

export { render, bump, setTarget, openWho, saveWho };
